// 应用提示文档

export default {
  title: '温馨提示',
  title_delay: '航班延误/取消',
  title_explain: '退改说明',
  title_Confirm_error: '提交失败',
  applicationSubmission: '申请提交',
  back: '返回',
  okBtn: '确定',
  cancel: '取消',
  goon: '继续',
  myOrder: '我的订单',
  goonRefund: '继续退票',
  goonChange: '继续变更',
  quitChange: '放弃变更',
  submit: '提交',
  allsubmit: '一起提交',
  ressubmit: '重新提交',
  keepsubmit: '继续提交',
  orderStatusChange: '您好！当前变更单的状态已改变，不可再进行支付',
  cardBin: '银行卡Bin',
  cardBinMsg: '是指公务卡卡号的前6位;</br>例如:工行的公务卡卡Bin是628288</br>',
  updateDetail: {
    title: '温馨提示',
    content:
      '您好！需先进行实名认证，您可以在移动端按以下任一方式认证：</br></br>1、南航APP首页—我—在线实名认证；</br>2、南航官网首页—服务大厅—在线实名验证；',
    noticket: '您好！根据您输入的信息，未找到可退改的客票，请重新输入。',
    cancelOrder: '您好！您确定要取消该变更单吗? ',
    cancelOrderOk: '取消变更成功！',
    cancelOrderFailed:
      '抱歉！暂时无法取消变更。请稍后重试或联系南航客服95539。',
    // '您好！您的客票状态不符，无法提交退票。您可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。', // GN: [ID1556600][2024-10-16]
    costCalculation: '费用计算',
    huChangeTip:'本渠道仅支持该客票办理自愿变更，若想办理航班不正常改签，请前往海航官网或者APP进行办理，如有疑问请联系在线客服或海航客服95339'
  },
  // EndorsedApply页面
  endorsedApply: {
    addPsgSuccess: '添加同行人成功',
    OneAdult: '您好！该旅客已进行过航班改期，后续将以改期的航班时间进行变更。',
    ManyAdult:
      '您好！该旅客已进行过航班改期，本次变更仅限航班时间相同的旅客，航班时间不同的旅客们需分别申请变更。',
    flightDelayOrCancel:
      '<p>1.国内客票可免费变更航班日期前后7天内（含航班当天）的航班。</p><p style="margin: 0.2rem 0;">2.国际客票可免费变更航班日期前7天、后14天（含航班当天）的航班。</p><p>3.头等舱、公务舱、明珠经济舱、经济舱全价票可选航班日期不受此限制。</p>',
    needSelectPsg: {
      content: '您好！添加同行人需先选择乘机人。',
    },
    pleaseSelectChangeFlightAndPsg: '请您先勾选所需变更的航段和乘机人！',
    pleaseSelectRefundFlightAndPsg: '请您先勾选所需退票的航段和乘机人！',
    pleaseSelectChangeFlight: '请您先勾选所需变更的航段！',
    pleaseSelectRefundFlight: '请您先勾选所需退票的航段！',
    pleaseSelectTrainFlight:
      '您好！若需单独退订高铁产品，可通过 “我的订单” - “假期” - “高铁订单” 操作退款',
    pleaseSelectPsg: '请您先勾选乘机人！',
    pleaseSelectHtlight:
      '您好！若需单独退订酒店产品，可通过“我的订单-酒店”操作退款',
    selectedPsgMustHasAdult:
      '您好！暂不支持单独儿童变更。如有疑问，请联系南航客服95539处理。',
    // GN: [ID1556600][2024-10-16]
    // '您好！暂不支持单独儿童变更。如有疑问，可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    selectedPsgbady:
      '您好！暂不支持单独婴儿自助变更。如有疑问，请联系南航客服95539处理。',
    // GN: [ID1556600][2024-10-16]
    // '您好！暂不支持单独婴儿自助变更，如有疑问，可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    selectedFlightError(text) {
      return `您好！${text}的航班需要勾选后方可进行一下步操作，请确定是否勾选该行段？`;
    },
    selectedFlightSuccess: '选择成功，请再选择下一段航班日期!',
    onlySelectOneAdultInTAOrder:
      '您好，此类型客票仅允许选择一个成人乘机人进行退票操作！',
    cancelCheckIn: '取消值机',
    selectMutiplePerson: '该产品同一订单的乘机人需同时退改，请勾选所有乘机人。',
  },
  // selectDate页面
  selectDate: {
    selectedFlightDateBefore:
      '您好！您选日期不能在前一个航班日期之前，请重新选择日期。',
    selectedFlightDateAfter:
      '您好！您选日期不能在后一个航班日期之后，请重新选择日期。',
    selectedFlightDateBeyondWQT:
      '该日期无法享受优惠变更手续费的权益，请确认是否更改日期。',
    selectedFlightDateSeasonTicket:
      '本期双城旅行产品旅行截止日期为2023年1月5日。您选择变更后的航班日期，后续产品保障不足90日。是否继续？',
    selectedFlightDateExceeds:
      '抱歉! 中转运价客票要求航班衔接时间不得大于24小时, 请重新选择',
    selectMuFlightDate:
      '您好！新航班日期在原航班日期前3天，后3天（含航班起飞当天）内可进行非自愿变更（免收手续费），当前您所选日期已超出限制，将按自愿变更处理（可能需支付费用）。点击【继续】，本次将按自愿变更处理，点击【重新选择】，可重新选择日期。'
  },
  // 选择新航班
  ticketChanges: {
    optionalFlight:
      '您好！当天除您已订的航班外，无其它可选航班，建议您重新选择日期，如有疑问，请联系在线客服咨询或原出票地办理。',
    electionFlight:
      '您有一段航班是处于重选状态，请选择完毕再进行其它航班重选！',
    checkpending:
      '本次变更的费用需要人工审核，在您选择完新航班并提交申请后，客服稍后短信通知您审核结果及变更费用。',
    changeCabin_1:
      '您好，该航班的明珠经济舱剩余座位不足或售罄，是否变更至经济舱？',
    changeCabin_2: '您好，该航班无明珠经济舱，是否变更至经济舱？',
    compareCabin(text) {
      return `您所选舱位为降舱变更，已兑换${text}不退还。`;
    },
  },
  // addPersonMessage页面
  addPersonMessage: {
    // addPersonMessage页面，请求afterSaleChangeConfirm接口成功的提示信息
    afterSaleChangeConfirm_ok: {
      title: '提交成功',
      content: '',
    },
    // addPersonMessage页面，请求afterSaleChangeConfirm接口出错的提示信息
    afterSaleChangeConfirm_error:
      "非常抱歉的通知您, 您的改签申请提交失败。 原因可能是您所选航班座位已售空， 或同时改签人数过多造成系统改签出错。你可以拔打<a href='tel://95539 '> <u>95539</u></a>人工服务垂询。",
    // GN: [ID1556600][2024-10-16]
    // '非常抱歉的通知您,您的改签申请提交失败。原因可能是您所选航班座位已售空，或同时改签人数过多造成系统改签出错。你可以可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    // addPersonMessage页面，请求afterSaleChangeConfirm接口出错的提示信息
    afterSaleChangeConfirm_fail: {
      title: '提示',
      content: '',
    },
  },
  // ApplySubmit页面
  applySubmit: {
    // ApplySubmit页面，提示用户输入联系人信息
    inputContactInfo: {
      content: '请输入并保存联系人信息',
    },
    // ApplySubmit页面，提示用户输入正确的联系人信息
    inputRightContactInfo: '您好！请输入正确的手机号',
    verificationCode: '请输入六位验证码！',
    // ApplySubmit页面，请求afterSaleChangeReqPayOK接口出错的提示信息
    afterSaleChangeReqPayOK_error:
      '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或拨打南航客服95539处理。',
    // GN: [ID1556600][2024-10-16]
    // '尊敬的旅客，您好！本次变更提交失败，您可以重新提交或可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
    // ApplySubmit页面，请求afterSaleChangeReqPayOK接口出错的提示信息
    afterSaleRefundApp_error:
      '尊敬的旅客，您好！退票申请中遇到问题，请重新提交或联系南航客服95539处理。',
    // 提示语优化暂时使用
    checkTips_fzy:
      '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消且无法恢复，实际退还金额将以审核结果为准；<br/>2、此次为非自愿退票，免收退票手续费。</div>',
    bingtui_zy:
      '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消且无法恢复，实际退还金额将以审核结果为准；<br/>2、您将提交病退申请，若您的材料符合要求，将为您免费办理退票；若您的材料不符合要求，系统将按自愿退票规则进行办理，自愿退票手续费可通过服务大厅“退改计算器”模块查看或联系客服咨询。</div>',
    checkTips_zy:
      '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消且无法恢复，实际退还金额将以审核结果为准；<br/>2、此次为自愿退票，按照客票使用条件可能产生相应退票手续费。</div>',
    yddqTip:
      '<strong style="color:#262626;">您好，我们将尽快完成退款审核，并短信通知您。</strong><div style="margin-top: 10px; text-align:left; color:#262626">温馨提示：<br/>1、您提交退票后原定座位将被取消，实际退还金额将以审核结果为准；<br/>2、本次因疫情原因申请的退票需要人工审核。如符合疫情文件，退票将按非自愿退票，免收退票手续费；如不符合疫情文件，退票将按自愿退票，按照客票使用条件可能产生相应退票手续费。</div>',
    quotaTip:
      '<span style="color:#e5004a">额度将在退票后几分钟内到账（若超出额度数不予退回），若未到账，可通过员工旅行-返回额度申请</span>',
    // contact_important: '联系人信息很重要，请补充完整。',
    contact_important: '请补充联系人信息',
    error_certno: '请输入证件号',
    error_certnoF: '请输入正确的证件号',
    error_name: '请输入持卡人',
    no_verification: '请输入验证码！',
    get_verification: '请获取验证码！',
    error_verification: '您输入的验证码有误，请重新输入。',
    overtime_verification: '您输入的验证码已超时，请重新获取。',
    eleven_phone: '请输入11位国内手机号。 ',
    isCheckedRead: '您好！请阅读并同意《隐私政策》。',
    artificial:
      '您好！本次变更需人工审核，客服稍后短信通知您审核结果及变更费用。',
    error_cardNo: '抱歉，您输入的银行卡信息有误，请重新输入。',
    no_bankcard: '请输入16-19位银行卡号',
    error_referral: '推荐码格式不正确！',
    changeCabin:
      '尊敬的旅客，您选择新航班的明珠经济舱已售罄，系统将自动为您安排同航班经济舱座位。<br/>变更成功后，您可前往南航机场柜台领取明珠经济舱体验券。<br/>请确认是否继续提交？',
    happyFlying:
      '您好！按照南航套票产品规则：机票一旦出票，不得变更、不得签转。',
    repeat: '文件名重复，无法上传，请更名后上传',
    selectedError:
      '附件上传格式为Word（.doc/.docx/.DOC/.DOCX）、Excel（.xls/.xlsx/.XLS/.XLSX）、PDF（.pdf/.PDF）、文本文件(.txt/.TXT) 或JPG(.jpg/.JPG)、PNG(.png/.PNG)格式，每个附件大小不能超20M',
    muFileError: '附件上传格式为"JPG", "PNG", "DOC", "JPEG", "DOCX"，所有附件大小不能超2M。',
    fileSize: '您好，您所提交的附件内容为空，请核对后提交，谢谢。',
    fileTip:
      '请根据实际情况，按需上传如下附件：1.情况说明 2.身份证正反面图片或其他身份证明官方材料 3.出行受阻官方证明材料 4.目的地活动延期或取消官方证明材料 5.健康码或核酸检测异常截图6.其他疫情原因导致无法出行的官方证明材料。',
    fileTipIll: '请上传南航认可医疗机构开具的医疗缴费发票或住院押金证明。',
    fileTipProof:
      '请根据实际情况，按需上传如下附件：<br/>1.本人手持购票证件（姓名页）和抗原检测阳性结果合照，要求本人人脸、姓名页证件和抗原阳性结果须同框。<br/>2.学校放假计划调整证明文件和学生证(封面和姓名页)图片。<br/>3.其他疫情原因导致无法出行的官方证明材料。',
    noRefundMode:
      '抱歉！由于系统操作权限原因，您暂无法办理退票，请您联系原出票地办理退票。',
    thanksPerson: '谢谢您的支持与配合！',
    contactInfo:
      '温馨提示：请您认真核对航班信息、乘机人姓名及证件信息、联系电话等，以免影响乘机。',
    transferInfo:
      '您的客票调整至中转航班后，如已预定附加服务可能无法保障，具体以现场核销为准,',
    pleaseCheckIsFood: '请您先勾选是否机上用餐',
  },
  // feeQuery 页面
  feeQuery: {
    selectFlight: '请选择想要退票或变更的航段! ',
    refundrules: '您好！根据退改规则，所有未使用航段必须同时申退。',
    canotChange: '您选择的航段不可变更，请重新选择',
    modification: '抱歉，您选择的航段不可变更',
  },
  // loginFeeQuery 页面
  loginFeeQuery: {
    inputTicketNoOrId: '请输入票号或者证件号！',
    inputName: '请输入旅客姓名！',
    inputTicketNo: '请输入航班号！',
    inputFlightDate: '请选择航班日期！',
  },
  // 退改计算器
  refundChangeCompute: {},
  // DetailsMessage 页面
  detailsMessage: {
    // detailsMessage 页面， 请输入联系人姓名提示
    inputContactPersonName: '联系人信息很重要，请补充完整',
    // detailsMessage 页面， 请输入正确的联系人姓名提示
    inputRightContactPersonName: '请输入正确的联系人姓名',
    // detailsMessage 页面， 请输入联系人手机提示
    inputContactPersonPhone: '联系人信息很重要，请补充完整',
    // detailsMessage 页面， 您输入的联系手机不正确，请重新输入提示
    inputRightContactPersonPhone: '您输入的联系手机不正确，请重新输入',
  },
  // RealNameVerify退款账户认证页面
  realNameVerify: {
    descTitle: '退款账户认证说明',
    descContent:
      '您提交的退票我们将把退款退回您（婴儿请提供携带成人的银行账户）本人的银行账户，请填写有效银联卡并完成认证，退款将在0-20个工作日退回到您提供的银行账户，具体时间以各家银行为准。',
    createRefundTa_error:
      '<div>很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者拔打<a style="display: inline-block;" href=\'tel:95539 \'> <u>95539</u></a>人工服务垂询。</div>',
    // '很抱歉，您的退票遇到问题，请关闭窗口后再次提交或者可点击“我要反馈”填写相关退改需求，后续客服将对您的需求进行处理和反馈。',
  },
  // ReformProcess 页面
  ReformProcess: {},
  // SubInfomation页面
  subInfomation: {
    payOverTime: {
      title: '支付超时',
    },
  },
  ElectronicInvoice: {
    noCompanyName: '请输入公司名称',
    noTaxpayerIdCode: '请输入纳税人识别码',
    noEmail: '请输入收票人邮箱',
    noPhone: '请输入收票人电话',
    erroeEmail: '邮箱输入有误，请重新输入',
    errorTaxpayerIdCode: '纳税人识别号不符合规则',
    errorPhone: '请正确输入收票人电话',
    tip:
      '点击“提交”后将为勾选的乘机人自动填充同样的发票信息并一并提交，请慎重勾选！',
  },
  changeMember: {
    checkMember: '您还没有勾选要入会的乘机人，请先勾选要入会的乘机人',
  },
  rateTip: {
    rateTip: '请选择评分！',
    rateSuccess: '感谢您的反馈！',
  },

  mileageMsg: {
    title(text) {
      return `${text}计算规则`;
    },
    info(text) {
      return `计算公式:<br/>实际过期${text}=过期${text} - 延期${text}<br/>实退${text}=应退${text} - 实际过期${text}`;
    },
    btn: '知道了',
  },
  cancelPage: {
    CancellationTip:
      '<p style="background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem; margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem" ><strong style="font-size:0.26rem;color:#009cd9"> 提前了解 </strong><br/> 请在取消行程前留意客票的退改政策，部分客票可能存在不允许变更或退票的规则</p><p style="background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem ;margin:0.1rem 0; text-align:left;color:#262626; font-size:0.2rem"><strong style="font-size:0.26rem;color:#009cd9"> 无法恢复</strong><br/>取消航班行程后，将无法再乘坐本航班，且无法恢复。</p><p style="background-color: #f1f9fc;border-radius: .12rem; padding:0.2rem;margin:0.1rem 0;text-align:left;color:#262626; font-size:0.2rem"><strong style="font-size:0.26rem;color:#009cd9"> 后续出行</strong><br/>在确定好新的行程后，您可在机票退改模块点击“变更”按钮，预订新的航班。</p>',
  },

};



// WEBPACK FOOTER //
// ./src/components/staticData/tips.js